import { render, staticRenderFns } from "./Voids.vue?vue&type=template&id=d3184984"
import script from "./Voids.vue?vue&type=script&lang=js"
export * from "./Voids.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports